// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__35GAU","location":"Header_location__8lL2O"};